import { IN_PERSON_TRAINING } from 'constants/actionTypes';

const initialState = {
  data: [],
  totalPages: 0,
  totalAttendees: 0,
  statusCounts: {},
  rsvpHideAlert: false,
  attendedGuestList: [],
};

export default (attendances = initialState, action) => {
  switch (action.type) {
    case IN_PERSON_TRAINING.ATTENDANCES.DATA_RECEIVE:
      return {
        ...attendances,
        data: action.payload.data,
        rsvpHideAlert: action.payload.rsvpHideAlert,
        totalPages: action.payload.totalPages,
        totalAttendees: action.payload.totalAttendees,
      };
    case IN_PERSON_TRAINING.ATTENDANCES.ATTENDED_GUEST_LIST:
      return {
        ...attendances,
        attendedGuestList: action.payload,
      };
    default:
      return attendances;
  }
};
